import styled, { css } from "styled-components";

export const Label = (props) => {
  return (
    <LabelDiv
      {...(props.$success && {
        $success: true,
      })}
      {...(props.$danger && {
        $danger: true,
      })}
    >
      {props.children}
    </LabelDiv>
  );
};

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LabelTitle = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div`
  font-size: 14px;
`;

const LabelDiv = styled.div`
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  gap: 5px;
  justify-content: center;
  padding: 4px 8px;

  ${(props) =>
    props.$success &&
    css`
      background-color: #009688;
    `};

  ${(props) =>
    props.$danger &&
    css`
      background-color: #e91e6399;
    `};
`;
